// extracted by mini-css-extract-plugin
export default {"fetching":"Homepage_fetching__3B1fv","errorRoot":"Homepage_errorRoot__h-2BW","list":"Homepage_list__2sTgI","listItem":"Homepage_listItem__3Hc02"};